/**
 * Baptist Cancer Center Doctor Search
 *
 * Replaces the previous Angular DoctorSearchController while preserving the
 * existing asynchronous search experience.
 *
 * Initial results are rendered server-side by DoctorSearch.cshtml.
 * Subsequent filtering, sorting, paging, and location changes request the
 * shared Razor partial from BccDoctorsController.Search and replace only the
 * results area.
 */
(function ($) {
    'use strict';

    var SEARCH_ENDPOINT = '/api/sitecore/BccDoctors/Search';

    /**
     * Initialize every doctor search component on the page.
     */
    $(document).ready(function () {
        $('[data-doctor-search-component]').each(function () {
            initializeDoctorSearch($(this));
        });
    });

    /**
     * Initialize one doctor search component.
     */
    function initializeDoctorSearch($component) {
        var $filterWrapper =
            $component.find('[data-doctor-filter-wrapper]');

        var $addressInput =
            $component.find('[data-doctor-address]');

        var $loading =
            $component.find('[data-doctor-loading]');

        /**
         * Return the current browser query string.
         */
        function getSearchParams() {
            return new URLSearchParams(
                window.location.search
            );
        }

        /**
         * Update the browser URL without reloading the page.
         *
         * Also keep the Secondary Hero search form synchronized with the
         * current asynchronous doctor search state.
         */
        function updateBrowserUrl(searchParams) {
            var queryString =
                searchParams.toString();

            var newUrl =
                window.location.pathname +
                (queryString ? '?' + queryString : '') +
                window.location.hash;

            window.history.pushState(
                { path: newUrl },
                '',
                newUrl
            );

            /*
             * Keep the Secondary Hero search form synchronized with the
             * current doctor search criteria.
             */
            $('form.bcc-search-form').each(function () {
                var $form = $(this);

                /*
                 * Remove the hidden query-string fields generated for
                 * asynchronous search state.
                 */
                $form
                    .find(
                        'input[type="hidden"][data-location-search-param]'
                    )
                    .remove();

                /*
                 * Add the current state back to the form.
                 *
                 * "q" is excluded because the hero already has a visible
                 * search input named q.
                 */
                searchParams.forEach(function (value, key) {
                    if (key === 'q') {
                        return;
                    }

                    $('<input>', {
                        type: 'hidden',
                        name: key,
                        value: value,
                        'data-location-search-param': ''
                    }).appendTo($form);
                });
            });
        }

        /**
         * Add/update/remove one query-string parameter.
         */
        function setSearchParam(
            searchParams,
            key,
            value
        ) {
            if (value === null ||
                value === undefined ||
                value === '') {

                searchParams.delete(key);
            }
            else {
                searchParams.set(key, value);
            }
        }

        /**
         * Return all selected cancer values.
         */
        function getSelectedCancers() {
            return $component
                .find('[data-doctor-cancer]:checked')
                .map(function () {
                    return $(this).val();
                })
                .get();
        }

        /**
         * Synchronize the left-side filter controls with the URL.
         */
        function syncFilterParams(searchParams) {
            var cancers =
                getSelectedCancers();

            setSearchParam(
                searchParams,
                'ct',
                cancers.length > 0
                    ? cancers.join(';')
                    : null
            );
        }

        /**
         * Toggle the loading indicator.
         */
        function setLoading(isLoading) {
            if (!$loading.length) {
                return;
            }

            if (isLoading) {
                $loading.show();
            }
            else {
                $loading.hide();
            }
        }

        /**
         * Request a new server-rendered doctor-results partial.
         */
        function getResults(resetPage) {
            var searchParams =
                getSearchParams();

            syncFilterParams(searchParams);

            if (resetPage) {
                searchParams.set('p', '1');
            }

            /*
             * Preserve the previous search behavior where distance defaults
             * to zero.
             */
            if (!searchParams.has('d')) {
                searchParams.set('d', '0');
            }

            updateBrowserUrl(searchParams);

            setLoading(true);

            $.ajax({
                url: SEARCH_ENDPOINT,
                method: 'GET',
                data: searchParams.toString(),
                cache: false
            })
                .done(function (html) {
                    var $currentResults =
                        $component.find(
                            '[data-doctor-results-container]'
                        );

                    /*
                     * _DoctorSearchResults.cshtml contains its own wrapper, so
                     * replace the complete current results container.
                     */
                    $currentResults.replaceWith(html);
                })
                .fail(function () {
                    alert('A search error occurred.');
                })
                .always(function () {
                    setLoading(false);
                });
        }

        /**
         * Apply a geocoded location to the search.
         */
        function updateLocation(result) {
            if (!result) {
                return;
            }

            var searchParams =
                getSearchParams();

            if ($addressInput.length &&
                result.address) {

                $addressInput.val(
                    result.address
                );
            }

            searchParams.set(
                'lt',
                result.lat
            );

            searchParams.set(
                'ln',
                result.lng
            );

            searchParams.set(
                'so',
                'DT'
            );

            searchParams.set(
                'p',
                '1'
            );

            updateBrowserUrl(
                searchParams
            );

            getResults(false);
        }

        /**
         * Run a Google Maps geocoder lookup.
         */
        function geoCode(query, callback) {
            if (!window.google ||
                !google.maps ||
                !google.maps.Geocoder) {

                return;
            }

            var geocoder =
                new google.maps.Geocoder();

            geocoder.geocode(
                query,
                function (results, status) {
                    if (status ===
                        google.maps.GeocoderStatus.OK &&
                        results &&
                        results.length > 0) {

                        var data =
                            results[0];

                        callback({
                            address:
                                data.formatted_address,

                            lat:
                                data.geometry
                                    .location
                                    .lat(),

                            lng:
                                data.geometry
                                    .location
                                    .lng()
                        });

                        return;
                    }

                    callback(null);
                }
            );
        }

        /**
         * Get the user's browser location.
         */
        function getCurrentLocation(callback) {
            if (!navigator.geolocation) {
                return;
            }

            navigator.geolocation
                .getCurrentPosition(
                    function (position) {
                        if (!position ||
                            !position.coords) {

                            return;
                        }

                        callback({
                            lat:
                                position.coords
                                    .latitude,

                            lng:
                                position.coords
                                    .longitude
                        });
                    }
                );
        }

        /*
         * Cancer filters.
         *
         * Cancer selection remains multi-select just as it was in the Angular
         * controller.
         */
        $component
            .find('[data-doctor-cancer]')
            .on('change', function () {
                getResults(true);
            });

        /*
         * Specialty selection.
         *
         * Unlike cancers, the doctor search supports only one specialty at a
         * time.
         */
        $component.on(
            'click',
            '[data-doctor-specialty]',
            function (e) {
                e.preventDefault();

                var specialty =
                    $(this).attr(
                        'data-doctor-specialty'
                    );

                var searchParams =
                    getSearchParams();

                setSearchParam(
                    searchParams,
                    's',
                    specialty
                );

                searchParams.set(
                    'p',
                    '1'
                );

                /*
                 * Preserve the old behavior where selecting a specialty closes
                 * the dropdown.
                 */
                $component
                    .find(
                        '.doctor-specialties .dropdown-toggle'
                    )
                    .dropdown('hide');

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /*
         * Clear specialty.
         */
        $component
            .find('[data-doctor-clear-specialty]')
            .on('click', function (e) {
                e.preventDefault();

                var searchParams =
                    getSearchParams();

                searchParams.delete('s');
                searchParams.set('p', '1');

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            });

        /*
         * Remove selected specialty from the result-summary chip.
         *
         * This uses delegated handling because the result partial is replaced
         * after every asynchronous request.
         */
        $component.on(
            'click',
            '[data-doctor-remove-specialty]',
            function (e) {
                e.preventDefault();

                var searchParams =
                    getSearchParams();

                searchParams.delete('s');
                searchParams.set('p', '1');

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /*
         * Clear all selected cancers.
         */
        $component
            .find('[data-doctor-clear-cancers]')
            .on('click', function (e) {
                e.preventDefault();

                $component
                    .find('[data-doctor-cancer]')
                    .prop('checked', false);

                getResults(true);
            });

        /*
         * Remove one cancer using its selected-filter chip.
         */
        $component.on(
            'click',
            '[data-doctor-remove-cancer]',
            function (e) {
                e.preventDefault();

                var cancer =
                    $(this).attr(
                        'data-doctor-remove-cancer'
                    );

                $component
                    .find('[data-doctor-cancer]')
                    .filter(function () {
                        return $(this).val() ===
                            cancer;
                    })
                    .prop('checked', false);

                getResults(true);
            }
        );

        /*
         * Clear location.
         */
        $component
            .find('[data-doctor-clear-location]')
            .on('click', function (e) {
                e.preventDefault();

                var searchParams =
                    getSearchParams();

                if ($addressInput.length) {
                    $addressInput.val('');
                }

                searchParams.delete('lt');
                searchParams.delete('ln');

                searchParams.set(
                    'so',
                    'AZ'
                );

                searchParams.set(
                    'p',
                    '1'
                );

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            });

        /*
         * Clear all doctor search filters.
         *
         * Delegated because a Clear All control also exists in the dynamic
         * results partial.
         */
        $component.on(
            'click',
            '[data-doctor-clear-all]',
            function (e) {
                e.preventDefault();

                var searchParams =
                    getSearchParams();

                $component
                    .find('[data-doctor-cancer]')
                    .prop('checked', false);

                if ($addressInput.length) {
                    $addressInput.val('');
                }

                searchParams.delete('s');
                searchParams.delete('ct');
                searchParams.delete('lt');
                searchParams.delete('ln');

                searchParams.set(
                    'so',
                    'AZ'
                );

                searchParams.set(
                    'p',
                    '1'
                );

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /*
         * Sort.
         */
        $component.on(
            'click',
            '[data-doctor-sort]',
            function (e) {
                e.preventDefault();

                var sort =
                    $(this).attr(
                        'data-doctor-sort'
                    );

                var searchParams =
                    getSearchParams();

                /*
                 * Distance sorting requires valid coordinates.
                 */
                if (sort === 'DT' &&
                    (!searchParams.get('lt') ||
                        !searchParams.get('ln'))) {

                    return;
                }

                searchParams.set(
                    'so',
                    sort
                );

                searchParams.set(
                    'p',
                    '1'
                );

                updateBrowserUrl(
                    searchParams
                );

                getResults(false);
            }
        );

        /*
         * Pagination.
         */
        $component.on(
            'click',
            '[data-doctor-page]',
            function (e) {
                e.preventDefault();

                var page =
                    parseInt(
                        $(this).attr(
                            'data-doctor-page'
                        ),
                        10
                    );

                if (!page ||
                    page < 1) {

                    return;
                }

                var searchParams =
                    getSearchParams();

                searchParams.set(
                    'p',
                    page
                );

                updateBrowserUrl(
                    searchParams
                );

                /*
                 * Preserve the previous Angular behavior of scrolling back to
                 * the sort/count row before retrieving another page.
                 */
                var $sortCount =
                    $component.find(
                        '.sort-count'
                    );

                if ($sortCount.length) {
                    $(
                        [
                            document.documentElement,
                            document.body
                        ]
                    ).animate(
                        {
                            scrollTop:
                                $sortCount
                                    .offset()
                                    .top
                        },
                        250
                    );
                }

                getResults(false);
            }
        );

        /*
         * Address search.
         */
        $component
            .find('[data-doctor-address-search]')
            .on('click', function () {
                var address =
                    $addressInput
                        .val()
                        .trim();

                if (!address) {
                    return;
                }

                geoCode(
                    {
                        address: address
                    },
                    function (result) {
                        updateLocation(
                            result
                        );
                    }
                );
            });

        /*
         * Allow Enter inside the location field to perform the same search.
         */
        $addressInput.on(
            'keydown',
            function (e) {
                if (e.key === 'Enter' ||
                    e.keyCode === 13) {

                    e.preventDefault();

                    $component
                        .find(
                            '[data-doctor-address-search]'
                        )
                        .trigger('click');
                }
            }
        );

        /*
         * Use current browser location.
         */
        $component
            .find('[data-doctor-current-location]')
            .on('click', function (e) {
                e.preventDefault();

                getCurrentLocation(
                    function (coords) {
                        geoCode(
                            {
                                location: coords
                            },
                            function (result) {
                                updateLocation(
                                    result
                                );
                            }
                        );
                    }
                );
            });

        /*
         * Mobile filters.
         */
        $component
            .find('[data-doctor-mobile-filter-open]')
            .on('click', function (e) {
                e.preventDefault();

                $filterWrapper
                    .addClass('show');
            });

        $component
            .find('[data-doctor-mobile-filter-close]')
            .on('click', function (e) {
                e.preventDefault();

                $filterWrapper
                    .removeClass('show');
            });

        /*
         * Preserve the existing behavior where the cancer dropdown stays open
         * while checkboxes are clicked.
         */
        $component
            .find(
                '.doctor-cancers .dropdown-menu'
            )
            .on('click', function (e) {
                e.stopPropagation();
            });

        /*
         * Browser Back/Forward.
         *
         * Reloading here guarantees the complete SSR state, including the
         * left-side filters, matches the restored URL.
         */
        $(window).on(
            'popstate.doctorSearch-' +
            $component.attr('id'),
            function () {
                window.location.reload();
            }
        );
    }

})(jQuery);